import { useEffect } from 'react';
import { useAuthToken, useAuthState } from '@mystudioclass/auth';
import { setTokenGetter } from '../services/api';

export default function AuthTokenProvider({ children }) {
  const { getToken } = useAuthToken();
  const { isSignedIn } = useAuthState();

  useEffect(() => {
    if (isSignedIn) {
      // Set the token getter for API calls
      setTokenGetter(() => getToken());
    } else {
      // Clear the token getter when signed out
      setTokenGetter(null);
    }
  }, [isSignedIn, getToken]);

  return children;
}
